import React from "react";
import PropTypes from "prop-types";
import getPrettyNumberFormat from "../../../helpers/getPrettyNumberFormat";
import PhasingGroup from "../models/PhasingGroup";

function PhasingGroupInfo({ item, actions }) {
  return (
    <>
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">Phasing Group</div>
        {actions}
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-40">Start</div>
        <div className="tw-max-w-80">
          {getPrettyNumberFormat(item.region.x0)}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-40">End</div>
        <div className="">{getPrettyNumberFormat(item.region.x1)}</div>
      </div>

      <div className="tooltip-row">
        <div className="tooltip-label tw-w-40">Length</div>
        <div className="">{getPrettyNumberFormat(item.region.size + 1)}</div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-40">Loaded Variant Count: </div>
        <div className="">{item.variantCount}</div>
      </div>

      <div className="tw-h-2" />
    </>
  );
}

PhasingGroupInfo.propTypes = {
  item: PropTypes.instanceOf(PhasingGroup).isRequired,
  actions: PropTypes.node,
};

PhasingGroupInfo.defaultProps = {
  actions: null,
};

export default React.memo(PhasingGroupInfo);
